import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { TransitionProposalPerformanceResponseSchema } from "../schemas";
export const url = (transitionProposalId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/transition-proposals/${transitionProposalId}/performance`
        : `https://middleware.uat.farther.com/transition-proposals/${transitionProposalId}/performance`;
};
export const getTransitionProposalPerformance = async (transitionProposalId, config) => {
    try {
        const { data } = await axios.get(url(transitionProposalId), {
            headers: {
                Authorization: `Bearer ${config.jwt}`,
                Client: config.clientId,
                ...(config.advisorId && { Advisor: config.advisorId }),
                Version: "20240424",
            },
        });
        const decoded = TransitionProposalPerformanceResponseSchema.safeParse(data);
        if (decoded.success) {
            return decoded.data;
        }
        else {
            const errorMessage = `[getTransitionProposalPerformance] Could not parse`;
            errorLog(errorMessage, decoded.error.message);
            throw new ValidationError(errorMessage, decoded.error.issues);
        }
    }
    catch (error) {
        const errorMessage = `[getTransitionProposalPerformance] Failed to get transition proposal performance`;
        errorLog(errorMessage, error instanceof Error ? error.message : String(error));
        throw error;
    }
};
export default getTransitionProposalPerformance;
//# sourceMappingURL=getTransitionProposalPerformance.js.map